const BlockedRandomization = require('./blocked');
const { randomInt, shuffle } = require('../math/seed-rng');
const { validateBlockSizes } = require('../math/validation');

class RandomBlockRandomization extends BlockedRandomization {
  constructor() {
    super();
    this.id = 'random-block';
    this.name = 'Random Block Size';
  }

  validateParams(params) {
    params.blockSizes = validateBlockSizes(params.blockSizes || `${params.arms * 2},${params.arms * 3}`, params.arms);
  }

  selectResultParameters(params) {
    return {
      studyName: params.studyName || '',
      n: params.n,
      arms: params.arms,
      armLabels: params.armLabels,
      seed: params.seed,
      technique: params.technique,
      blockSizes: params.blockSizes
    };
  }

  randomize(rng, params) {
    const sequence = [];
    let patientIndex = 0;
    let blockNumber = 1;

    while (patientIndex < params.n) {
      const blockSize = params.blockSizes[randomInt(rng, 0, params.blockSizes.length)];
      const blockArms = this.buildBalancedBlock(params.arms, blockSize);
      const randomizedBlock = shuffle(blockArms, rng);

      for (const armIndex of randomizedBlock) {
        if (patientIndex >= params.n) {
          break;
        }

        sequence.push(this.buildAssignment(patientIndex, armIndex, {
          blockNumber,
          blockSize
        }));
        patientIndex += 1;
      }

      blockNumber += 1;
    }

    return sequence;
  }

  getExplanation() {
    return `
      <h3>Random Block Size</h3>
      <p>The app chooses each block size from the allowed list, then shuffles a balanced block using the seed.</p>
      <pre>For each block:
  block_size = seeded random choice from allowed sizes
  create balanced arm list
  shuffle list using seed</pre>
      <p>Variable blocks preserve balance while reducing predictability.</p>
    `;
  }
}

module.exports = RandomBlockRandomization;
